import React from "react";
import uuid from "react-uuid";
import ChartOptions from "./ChartOptions";
import DataTypesFilter from "./DataTypesFilter";
export const sidebarLibrary = [

  {
    title: "Alarm Chart Options",
    item: <ChartOptions />,
    expanded: false,
  },
  {
    title: "Timeline Data Types",
    item: <DataTypesFilter />,
    expanded: false,
  },
];
